import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import BaseApp, { ISearchParam } from '../../features/BaseApp'
import { Avatar, IconButton } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import { IDataDisplayerPagination } from '../DataDisplayer/DataDisplayer'
import BasicModalWindow from '../BasicModalWIndow'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import { IAxiosDefaultDataObject } from '../../config'
import GridData from '../GridData/GridData'
import { GridDataColumns, IModalObject } from '../GridData'
import AdminDynamicCreateOrUpdatePage from '../../features/admin/AdminDynamicCreateOrUpdatePage'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'

interface ISelectedDynamicItemBoxProps {
    id: number,
    title: string,
    thumbnail: string,
    resetItem: (id: number) => void
}

function SelectedDynamicItemBox(props: ISelectedDynamicItemBoxProps){

    const { id, title, thumbnail, resetItem } = props

    return(
        <div className="selected-item-box-field">
            <div className="content-of-selected-item-box-field">

                <div className="thumb-of-selected-item-box-field">
                    <div className="content-of-thumb-of-selected-item-box-field">
                        <Avatar src={thumbnail}>
                            <GenerateIcon icon="image" />
                        </Avatar>
                    </div>
                </div>

                <div className="text-of-selected-item-box-field">
                    <div className="content-of-text-of-selected-item-box-field">
                        <h3>{title}</h3>
                    </div>
                </div>

                <div className="action-button-of-selected-item-box-field">
                    <div className="content-of-action-button-of-selected-item-box-field">
                        <IconButton color="error" onClick={() => resetItem(id)}>
                            <GenerateIcon icon="close" />
                        </IconButton>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default function DynamicModelSelect(props: IBaseDynamicFormElement) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, data, selectLabel, gridColumns, filterForm, updateSearchParamsBeforeLoadItems, disabled, disableAddNewItem } = props

    const appClass = props.appClass ? props.appClass : new BaseApp()

    const [open, setOpen] = useState<boolean>(false)

    const selectedItem: number = data.value

    const [item, setItem] = useState<IAxiosDefaultDataObject | null>()

    const [items, setItems] = useState<IAxiosDefaultDataObject[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const [selectedItems, setSelectedItems] = useState<IAxiosDefaultDataObject[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])

    const [newItemModal, seNewItemModal] = useState<boolean>(false)

    /**
     * Handle close modal
     */
    const handleCloseModal = () => setOpen(false)

    /**
     * Handle open modal
     */
    const handleOpenModal = () => setOpen(true)

    /**
     * Handle change
     */
    const handleChange = (id: number | null) => {
        props.handleOnChange(props.id, id)
    }

    /**
     * Load selected item
     */
    const loadItem = () => {
        if (!selectedItem){
            setItem(null)
            return;
        }

        setLoading(true)
        appClass.singleInstanceDetails(selectedItem)
            .then(response => {
                setItem(response.data)
                setLoading(false)
                handleChange(response.data.id)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    useEffect(() => {
        loadItem()
    }, [selectedItem])

    /**
     * Update item id
     */
    const updateItemId = (id: number) => {
        props.handleOnChange(props.id, id ? id : null)
        handleCloseModal()
    }

    /**
     * No item selected
     */
    const noItemSelected = () => {
        return(
            <span className="no-item-selected-box" onClick={() => setOpen(true)}>{selectLabel ? selectLabel : "Select"}</span>
        )
    }

    /**
     * Loading
     */
    const loadingBlock = () => {
        return(
            <span className="no-item-selected-box">Loading...</span>
        )
    }


    const [columns, setColumns] = useState<GridDataColumns>([])

    const handleAfterAddNew = () => {
        seNewItemModal(false)
    }

    const handleUpdateItem = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => {
        setItems([
            item,
            ...items,
        ])
    }

    useEffect(() => {
        if (!gridColumns || gridColumns.length === 0) return;

        const updatedColumns = gridColumns.map((col) => {
            if (col.type === "title") {
            return {
                ...col,
                cellRendererParams: {
                appClass: () => appClass,
                enableQuickPreview: false,
                onClick: (data: IModalObject) => {
                    if (data) {
                    updateItemId(data.id);
                    }
                },
                },
            };
            }
            return col;
        });

        setColumns(updatedColumns);

    }, [gridColumns]);

    return(
        <div className="dynamic-model-elem-select-container">

            {!disableAddNewItem && (
                <BasicModalWindow
                    shown={newItemModal}
                    handleClose={() => seNewItemModal(false)}
                    size="fullscreen"
                    actionButtons={[
                        {
                            label: "Close",
                            onClick: () => seNewItemModal(false),
                            color: "error"
                        }
                    ]}
                    
                    showHeader
                    title={appClass.messages.create}
                >
                    <AdminDynamicCreateOrUpdatePage customPageType="new" noRedirect={true} afterSuccess={handleAfterAddNew} forceCreatePage={true} hidePageHeadBox={true} customPageName={appClass.appName} updateItem={handleUpdateItem} />
                </BasicModalWindow>
            )}

            <BasicModalWindow
                shown={open}
                handleClose={handleCloseModal}
                size="lg"
                actionButtons={[
                    {
                        label: "Close",
                        onClick: handleCloseModal,
                        color: "error"
                    }
                ]}
                actionButtonsBottom
                showHeader
                title={selectLabel ? selectLabel : "Select"}
            >
                <GridData 
                    items={items}
                    columns={columns}
                    actionButtons={[
                        // {
                        //     icon: "new",
                        //     color: "success",
                        //     isIconButton: true,
                        //     // label: "Select",
                        //     onClick(data, dispatch, navigate) {
                        //         updateItemId(data.id)
                        //     },
                        // }
                    ]}
                    handleLoadItems={(page, search, disablePagination, addItems, searchParamsList) => appClass.listOfInstances(page, search, disablePagination, addItems, searchParams)}
                    onDeleteItem={(id) => appClass.deleteInstance(id)}
                    onDeleteManyItems={(records) => appClass.deleteManyInstances(records)}
                    deleteItem={(id, dispatch) => {}}
                    updateItem={(item, dispatch) => {}}
                    headerOptions={[
                        {
                            label: appClass.messages.createShort,
                            icon: "new",
                            onClick: () => seNewItemModal(true),
                            disabled: disableAddNewItem
                        }
                    ]}
                    loading={loading}
                    pagination={pagination}
                    search={search}
                    selectedItems={selectedItems}
                    searchParams={searchParams}
                    updateSearch={(search) => setSearch(search)}
                    setSelectedItems={(items) => setSelectedItems(items)}
                    updateLoading={(status) => setLoading(status)}
                    updateItemSearchParams={(params) => setSearchParams(params)}
                    addNewItem={(item) => {
                        console.log("addNewItem", item)
                        setItems([
                            ...items,
                            item
                        ])
                    }}
                    updateAllItems={(items) => {
                        console.log("updateAllItems", items)
                        setItems(items)
                    }}
                    updateItemsPagination={(pagination) => setPagination(pagination)}
                    config={{
                        viewItemLink: "",
                        editItemLink: "",
                        disableActionButtons: true,
                        disableDelete: true,
                        disableSelect: true,
                        actionButtons: {
                            pinned: "left",
                            width: 80,
                        },
                        filterForm: filterForm,
                        disableRemoveEmptySearchParams: true
                    }}
                    updateSearchParamsBeforeLoadItems={updateSearchParamsBeforeLoadItems}
                />
            </BasicModalWindow>

            <div className={disabled ? "selected-item-field-container disabled" : "selected-item-field-container"}>
                <div className="content-of-selected-item-field-container">
                    {label && <div className="label-of-selected-item-field-container">{label}</div>}
                    {loading ? loadingBlock() : item !== null ? <SelectedDynamicItemBox id={item ? item.id : 0} title={item ? item.title : ""} thumbnail={item ? item.thumbnail : ""} resetItem={(id) => handleChange(0)} /> : noItemSelected()}
                </div>
            </div>

        </div>
    )
}